import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import Resources from '../../core/constants/resources';

import { SessionStorageService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class PreventLandingGuardService implements CanActivate {

  constructor(
    private router: Router,
    private sessionService: SessionStorageService
  ) { }

  // Can activate
  canActivate(): boolean {
    if (this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.IsLoggedInUser)) {
      return true;
    } else {
      // this.router.navigate(['login'])
      return true;
    }
  }
}
